var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLangIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04995 13H7.52695C7.69807 16.1669 8.7075 19.2314 10.452 21.88C8.2667 21.537 6.25674 20.4794 4.73636 18.8728C3.21598 17.2661 2.27192 15.2008 2.04995 13ZM2.04895 11C2.27066 8.79913 3.21549 6.73377 4.73568 5.12691C6.25588 3.52004 8.26573 2.46227 10.451 2.119C8.7065 4.76761 7.69707 7.83215 7.52595 10.999L2.04895 11ZM21.9489 11H16.472C16.301 7.83281 15.2916 4.7679 13.547 2.119C15.7322 2.46202 17.7422 3.51956 19.2625 5.12624C20.7829 6.73293 21.728 8.79816 21.95 10.999M21.95 12.999C21.728 15.1997 20.7831 17.2648 19.2629 18.8715C17.7428 20.4782 15.733 21.5358 13.548 21.879C15.2922 19.2307 16.3017 16.1665 16.4729 13L21.95 12.999ZM9.52995 13H14.47C14.3054 15.6995 13.4553 18.3124 12 20.592C10.5446 18.3124 9.69455 15.6995 9.52995 13ZM9.52995 11C9.69455 8.30052 10.5446 5.68757 12 3.408C13.4553 5.68757 14.3054 8.30052 14.47 11H9.52995Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLangIcon);
export default __webpack_public_path__ + "static/media/mainLangIcon.6eea07b8c4370c9f7a77146e026e9f67.svg";
export { ForwardRef as ReactComponent };